import * as types from '../ActionTypes/WorkoutsActionTypes';
import { WorkoutModel } from '../../BusinessLogic/Models/WorkoutModel';
import { DayWeekWorkoutModel } from '../../BusinessLogic/Models/DayWeekWorkoutModel';
import { getDayWeekWorkoutModelsArray, getWorkoutModelsArray } from './helpers';

const initialState = {
    statuses: {
        areWorkoutsOfTheDayLoading: false,
        isWorkoutOfTheDayAdding: false,
        isWorkoutOfTheWeekLoading: false,
        isWorkoutOfTheWeekAdding: false,
        isStockImageLoading: false,
        isWorkoutLoading: false,
        plannedWorkoutsLoading: false,
        isWorkoutImageUploading: false,
        isWorkoutCreating: false,
    },
    stockImage: '',
    plannedWorkouts: [],
    currentWorkouts: {},
    workoutsOfTheDay: [],
    workoutOfTheWeek: {},
};

export function WorkoutsReducer(state = initialState, { type, payload, meta, ...action }) {
    switch (type) {
        case types.GET_WORKOUT_BY_ID_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutLoading: true,
                },
            };
        }

        case types.GET_WORKOUT_BY_ID_SUCCESS: {
            const workoutModel = new WorkoutModel(payload);
            const newWorkoutsObject = {
                [payload.id]: { ...workoutModel.workout },
            };

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    workoutInfoLoading: false,
                },
                currentWorkouts: { ...state.currentWorkouts, ...newWorkoutsObject },
            };
        }

        // case types.GET_WORKOUT_BY_ID_FAILED: {}

        case types.GET_WORKOUT_STOCK_IMAGE_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    stockImageLoading: true,
                },
            };
        }

        case types.GET_WORKOUT_STOCK_IMAGE_SUCCESS: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    stockImageLoading: false,
                },
                stockImage: payload,
            };
        }

        // PLANNED WORKOUTS
        case types.GET_PLANNED_WORKOUTS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    plannedWorkoutsLoading: true,
                },
            };
        }

        case types.GET_PLANNED_WORKOUTS_SUCCESS: {
            const workoutsArray = getWorkoutModelsArray(payload);

            return {
                ...state,
                plannedWorkouts: [...workoutsArray],
                statuses: {
                    ...state.statuses,
                    plannedWorkoutsLoading: false,
                },
            };
        }

        // case types.GET_PLANNED_WORKOUTS_FAILED: {}

        case types.UPLOAD_WORKOUT_IMAGE_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutImageUploading: true,
                },
            };
        }

        case types.UPLOAD_WORKOUT_IMAGE_SUCCESS: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutImageUploading: false,
                },
            };
        }

        case types.UPLOAD_WORKOUT_IMAGE_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutImageUploading: false,
                },
            };
        }

        case types.CREATE_WORKOUT_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutCreating: true,
                },
            };
        }

        case types.CREATE_WORKOUT_SUCCESS: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutCreating: false,
                },
            };
        }

        case types.CREATE_WORKOUT_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutCreating: false,
                },
            };
        }

        case types.GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    areWorkoutsOfTheDayLoading: true,
                },
            };
        }

        case types.GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_SUCCESS: {
            const workoutsArray = getDayWeekWorkoutModelsArray(payload);

            return {
                ...state,
                workoutsOfTheDay: [...workoutsArray],
                statuses: {
                    ...state.statuses,
                    areWorkoutsOfTheDayLoading: false,
                },
            };
        }

        case types.ADD_WORKOUT_OF_THE_DAY_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutOfTheDayAdding: true,
                },
            };
        }

        case types.ADD_WORKOUT_OF_THE_DAY_SUCCESS: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutOfTheDayAdding: false,
                },
            };
        }

        case types.GET_WORKOUT_OF_THE_WEEK_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutOfTheWeekLoading: true,
                },
            };
        }

        case types.GET_WORKOUT_OF_THE_WEEK_SUCCESS: {
            let dayWeekWorkoutModel = {};
            if (Array.isArray(payload)) dayWeekWorkoutModel.workout = {};
            else dayWeekWorkoutModel = new DayWeekWorkoutModel(payload);

            return {
                ...state,
                workoutOfTheWeek: { ...dayWeekWorkoutModel.workout },
                statuses: {
                    ...state.statuses,
                    isWorkoutOfTheWeekLoading: false,
                },
            };
        }

        case types.ADD_WORKOUT_OF_THE_WEEK_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutOfTheWeekAdding: true,
                },
            };
        }

        case types.ADD_WORKOUT_OF_THE_WEEK_SUCCESS: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isWorkoutOfTheWeekAdding: false,
                },
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/WorkoutsReducer.js